// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 230 ? "component---src-pages-index-jsx" : chunkId) + "-" + {"223":"65e2e7d4eece8523ad1d","230":"b70079fed04ea54df4b3","843":"41e620e0d49d9d0669c9"}[chunkId] + ".js";
};